<ng-container *ngIf="{ isMobile: isMobile$ | async } as obs">
  <div *ngIf="(loading$ | async) === false; else skeleton" class="list">
    <sd-pickup-add-shop text="Добавить пункт" *ngIf="!obs.isMobile"></sd-pickup-add-shop>
    <sd-pickup-shop *ngFor="let shop of shopList$ | async" [shop]="shop"></sd-pickup-shop>
  </div>
  <sd-pickup-add-shop text="Добавить пункт" *ngIf="obs.isMobile"></sd-pickup-add-shop>

  <ng-template #skeleton>
    <div class="list">
      <div class="skelet"></div>
      <div class="skelet"></div>
      <div class="skelet"></div>
    </div>
  </ng-template>
</ng-container>
